import React from 'react';
import {
  useQuery,
  useParameterizedQuery
} from 'react-fetching-library';
import Page from '../../components/Page';
import {
  Box,
  Card,
  CardContent,
  Stack,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  Typography,
  IconButton,
  Menu,
  Divider,
  Button
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  getManagerPeriodsAction,
  getEmployeesByPeriodAction
} from '../../services/request';
import Scrollbar from '../../components/Scrollbar';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { plPL } from '@mui/x-data-grid';
import { managerEmployeesTableColumns } from '../../services/column-definitions';
import toast from 'react-hot-toast';
import { useManager } from '../../pages/Manager';
import EmployeeDetails from './employee-details/EmployeeDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COORDINATOR, MANAGER, MANAGERASSIST } from '../employee/applications/functions';

const defaultResorts = [
  { label: 'Ośrodek Sun Sport w Mrówkach', value: 1 },
  { label: 'Ośrodek Michasiówka w Giewartowie', value: 2 }
];
export default function EmployeesTable({ manager }) {
  const { application, applications, managerEmployees, setManagerEmployees, setManagerEmployee, weekPeriod, setWeekPeriod } = useManager();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { loading, payload, error, query } = useQuery(getManagerPeriodsAction());
  const { query: getEmployeesQuery, loading: getEmployeesLoading } = useParameterizedQuery(getEmployeesByPeriodAction);


  const [weekPeriods, setWeekPeriods] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);
  const [resort, setResort] = React.useState('');
  const [availableResorts, setAvailableResorts] = React.useState([]);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  React.useEffect(() => {
    if (!error && !loading && payload.length > 0 && weekPeriods.length === 0) {
      setWeekPeriods(payload);
      setWeekPeriod(payload[0]);
      if (payload[0].name.includes('Tydzień')) {
        const resortsForAgreement = applications.filter(a => [COORDINATOR, MANAGER, MANAGERASSIST].includes(a.function_type)).map(
          a => a.resort_for_agreement
        );
        setAvailableResorts(defaultResorts.filter(dr => resortsForAgreement.includes(dr.value)));
      }
    }
    if (error) {
      toast.error('Wystąpił błąd');
    }
  }, [loading]); //

  const fetchEmployees = async () => {
    const { error, payload } = await getEmployeesQuery({ period: weekPeriod, resort });

    if (!error) {
      setManagerEmployees(payload);
    } else {
      toast.error('Błąd podczas pobierania pracowników.');
    }
  };

  const handleOpenDetails = id => {
    setManagerEmployee(managerEmployees.find(item => item.id === id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setManagerEmployee({});
  };

  const handleChangePeriod = event => {
    const selectedPeriod = weekPeriods.find(period => period.nr === event.target.value);
    setWeekPeriod(selectedPeriod);
    setResort('');
    if (selectedPeriod.name.includes('Tydzień')) {
      const resortsForAgreement = applications.filter(a => [COORDINATOR, MANAGER, MANAGERASSIST].includes(a.function_type)).map(
        a => a.resort_for_agreement
      );
      setAvailableResorts(defaultResorts.filter(dr => resortsForAgreement.includes(dr.value)));
    }
  };

  const handleDisabled = () => {
    if (isZsPeriod()) {
      if (resort) {
        return false;
      }
    } else if (weekPeriod) {
      return false;
    }

    return true;
  };

  const isZsPeriod = () => weekPeriod?.name.includes('Tydzień');

  const BoolIcon = ({ value }) => (
    <FontAwesomeIcon
      icon={value && value.length > 0 ? ['fas', 'check'] : ['fas', 'times']}
      color={value && value.length > 0 ? 'green' : 'red'}
      size="xs"
    />
  );

  if (!application) {
    return null;
  }


  if (![MANAGER, COORDINATOR, MANAGERASSIST].includes(application.function_type)) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h2" color="error" align="center">Ta aplikacja nie ma dostępu do tej zakładki</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Page title="Pracownicy">
      <Card>
        <CardContent>
          {weekPeriod && (
            <Stack justifyContent={'end'} mb={3}>
              <FormControl sx={{ minWidth: ' 160px' }}>
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Wybierz termin
                </InputLabel>
                <Select
                  placeholder="Wybierz termin"
                  variant="standard"
                  labelId="periods"
                  value={weekPeriod.nr}
                  defaultValue={weekPeriod.nr}
                  label="Sezony"
                  onChange={e => handleChangePeriod(e)}
                >
                  {weekPeriods &&
                    weekPeriods.map((obj, idx) => (
                      <MenuItem key={idx} value={obj.nr}>
                        {obj.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Stack>
          )}
          {weekPeriod && isZsPeriod() && (
            <Stack justifyContent={'end'} mb={3}>
              <FormControl sx={{ minWidth: ' 160px' }}>
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Wybierz ośrodek
                </InputLabel>
                <Select
                  placeholder="Wybierz ośrodek"
                  variant="standard"
                  labelId="resort"
                  value={resort}
                  label="Ośrodek"
                  onChange={e => setResort(e.target.value)}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  {availableResorts &&
                    availableResorts.map(obj => (
                      <MenuItem key={obj.value} value={obj.value}>
                        {obj.label}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Stack>
          )}
          <Button sx={{ width: '100%' }} variant="contained" color="primary" disabled={handleDisabled() || getEmployeesLoading} onClick={() => fetchEmployees()}>
             Pokaż pracowników
          </Button>


          {managerEmployees.length > 0 && isMobile ? (
            <>
              <List>
                {managerEmployees.length > 0 && managerEmployees.map(row => (
                  <ListItem key={row.id} divider>
                    <ListItemText primary={<Typography><b>Pracownik:</b> {row.name} {row.surname}</Typography>} secondary={<Stack direction="column">
                      <Divider flexItem />
                      <Typography><b>Stanowisko:</b> {row.function_type_display}</Typography>
                      <Typography><b>Opinia:</b> <BoolIcon value={row.reviews} /></Typography>
                      <Typography><b>Punkty:</b> <BoolIcon value={row.points} /></Typography>
                    </Stack>} />
                    <IconButton onClick={event => handleMenuOpen(event, row)}>
                      <MoreVertIcon />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => {
                  handleOpenDetails(menuRow.id);
                  handleMenuClose();
                }}>
                  <EditIcon style={{ marginRight: 8 }} /> Edytuj
                </MenuItem>
              </Menu>
            </>
          ) : managerEmployees.length > 0 && (
            <Scrollbar>
              <Box sx={{ minWidth: { md: 800 }, mt: 4 }}>
                <DataGridPro
                  columns={managerEmployeesTableColumns(handleOpenDetails)}
                  rows={managerEmployees || []}
                  density="standard"
                  disableColumnMenu={true}
                  autoPageSize={false}
                  autoHeight={true}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  pagination
                  components={{
                    Toolbar: null
                  }}
                  localeText={
                    plPL.components.MuiDataGrid.defaultProps.localeText
                  }
                  disableSelectionOnClick
                />
              </Box>
            </Scrollbar>
          )}
        </CardContent>
      </Card>
      {open && <EmployeeDetails open={open} onClose={handleClose} />}
    </Page>
  );
}
